import styled from 'styled-components';
import { Table, FovButton } from 'components/generic';
import { getColor } from 'utils';

import constants from 'constants/index';

const light = constants.THEME.LIGHT;

export const NameContainer = styled('div')`
    padding-right: 0.5rem;
    width: 20rem;
`;

export const MemberContainer = styled(Table)`
    border: 0.0625rem solid #ccc;
    border-radius: 0.25rem;
    border-color: ${props => getColor(props, 'mediumGrey')};
`;

export const IconButton = styled(FovButton)`
    width: fit-content;
    padding: 0;
    background-color: ${props => getColor(props, props?.backgroundColor || 'primary')};

    &:hover {
       background-color: ${props => {
        const lightTheme = props.$selectedTheme === light;
        return props?.hoverColor || getColor(props, lightTheme ? 'mediumGrey' : 'accent');
       }};
    }
`;

export const AddCreatorButton = styled(FovButton)`
       position: relative;
       width: fit-content;
       cursor: pointer;
       background-color: ${props => getColor(props, 'accent')};
       margin-right: 0;
       margin-left: auto;
       color: ${props => getColor(props, 'onPrimary')};
       &: hover {
         background-color: ${props => getColor(props, 'accentHover')};
       }
`;

export const TitleContainer = styled('div')`
    display: inline-flex;
    justify-content: space-between;
    width: 100%;
`;

export const TitleRow = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

export const TabContainer = styled('div')`
    position: relative;
    display: inline-flex;
    padding: 1rem 0;
    width: 100%;
`;

export const Tab = styled(FovButton)`
    position: relative;
    width: fit-content;
    margin: 0 0.5rem;
    background-color: ${props => {
        return getColor(props, props.selected ? 'accent' : 'onPrimary');
    }};
    &:hover {
        background-color: ${props => getColor(props, 'accentHover')};
    }

`;